<template>
  <div
    v-if="x.totalResults"
    class="x-desktop-toolbar x-mt-16 x-flex x-items-center x-justify-end x-gap-24"
    :class="{ 'x-mb-8': !x.selectedFilters.length }"
    data-test="total-results"
  >
    <i18n-t
      class="x-text1 x-text1-lg x-flex-auto x-font-alternative x-text-neutral-90"
      keypath="totalResults.message"
      tag="span"
      scope="global"
      :plural="x.totalResults"
    >
      <template #totalResults>
        {{ x.totalResults }}
      </template>
      <template #query>
        <span class="x-title3">
          {{ x.spellcheckedQuery || query }}
        </span>
      </template>
    </i18n-t>

    <BaseIdModalOpen
      modal-id="right-aside"
      class="x-button-outlined x-rounded-full x-border-0 hover:x-border hover:!x-border-lead-75"
      data-test="toggle-facets-button"
    >
      <FilterIcon class="x-icon-lg" />
      <span class="x-text1 x-text1-lg x-font-bold x-text-lead-75">{{
        $t('toggleAside.showAside')
      }}</span>
      <span
        v-if="x.selectedFilters.length"
        :class="{ 'x-badge-circle': x.selectedFilters.length <= 9 }"
        class="x-badge x-bg-lead-90"
      >
        {{ x.selectedFilters.length }}
      </span>
    </BaseIdModalOpen>

    <SortSelector />
  </div>
</template>

<script setup lang="ts">
import { BaseIdModalOpen, use$x, useGetter } from '@empathyco/x-components'
import FilterIcon from '../icons/filter-icon.vue'
import SortSelector from '../search/sort-selector.vue'

const x = use$x()
const { query } = useGetter('search')
</script>
<style lang="scss">
.x-desktop-toolbar {
  .x-button-outlined {
    font-weight: 400;
    background-color: transparent;
    border-color: var(--button-color-25);
    color: var(--button-color-90);

    &.x-selected,
    &:active,
    &:hover {
      border-color: var(--button-color-25);
      background-color: var(--button-color-25);
      color: #000;
    }
  }
}
</style>
